import { render } from "./VoiceAgent.vue?vue&type=template&id=6c9305a4&scoped=true"
import script from "./VoiceAgent.vue?vue&type=script&lang=js"
export * from "./VoiceAgent.vue?vue&type=script&lang=js"

import "./VoiceAgent.vue?vue&type=style&index=0&id=6c9305a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9305a4"]])

export default __exports__